(() => {
  const backInStockFormIds = new Set(['SsRKTZ']);

  const styleKlaviyoPopupForm = (form, isBackInStock = false) => {
    const dialog = form.closest('[role="dialog"]');
    if (!dialog) return false;

    dialog.classList.add('jm-klaviyo-popup');
    dialog.classList.toggle('jm-klaviyo-popup--back-in-stock', isBackInStock);
    form.classList.add('jm-klaviyo-popup__form');

    const closeButton = dialog.querySelector('.klaviyo-close-form, [aria-label="Close dialog"]');
    if (closeButton && !closeButton.classList.contains('jm-klaviyo-popup__close')) {
      closeButton.classList.add('jm-klaviyo-popup__close');
      closeButton.replaceChildren(document.createTextNode('CLOSE'));
    }

    form.querySelectorAll('[data-testid="form-row"]').forEach((row) => {
      if (row.querySelector('.klaviyo-form-image')) row.classList.add('jm-klaviyo-popup__image-row');
      if (row.querySelector('.klaviyo-form-richtext')) row.classList.add('jm-klaviyo-popup__copy-row');
      if (row.querySelector('input[type="email"]')) row.classList.add('jm-klaviyo-popup__email-row');
      if (row.querySelector('.klaviyo-promocheckbox')) row.classList.add('jm-klaviyo-popup__checkbox-row');
      if (row.querySelector('.klaviyo-form-button')) row.classList.add('jm-klaviyo-popup__submit-row');
    });

    return true;
  };

  const initializeKlaviyoPopupStyling = (trigger) => {
    if (trigger.dataset.stylingInitialized === 'true') return;

    const formId = trigger.dataset.formId;
    if (!formId) return;

    trigger.dataset.stylingInitialized = 'true';

    const stylePopup = () => {
      const forms = document.querySelectorAll('form[data-testid^="klaviyo-form-"]');

      forms.forEach((form) => {
        if (form.dataset.testid !== `klaviyo-form-${formId}`) return;
        styleKlaviyoPopupForm(form);
      });
    };

    stylePopup();

    const observer = new MutationObserver(stylePopup);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const initializeBackInStockPopupStyling = () => {
    let stylingExpiresAt = 0;

    const styleBackInStockButtons = () => {
      document.querySelectorAll('button[data-a11y-identifier^="bis-button-"]').forEach((button) => {
        if (button.textContent.trim() !== 'Notify Me') {
          button.textContent = 'Notify Me';
        }
      });
    };

    const styleBackInStockPopup = () => {
      styleBackInStockButtons();

      document.querySelectorAll('form[data-testid^="klaviyo-form-"]').forEach((form) => {
        const formId = form.dataset.testid.replace('klaviyo-form-', '');
        const isKnownBackInStockForm = backInStockFormIds.has(formId);
        if (!isKnownBackInStockForm && Date.now() > stylingExpiresAt) return;

        const dialog = form.closest('[role="dialog"]');
        if (!dialog) return;
        if (styleKlaviyoPopupForm(form, true)) stylingExpiresAt = 0;
      });
    };

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.klaviyo-bis-trigger')) return;
      stylingExpiresAt = Date.now() + 10000;
      window.setTimeout(styleBackInStockPopup, 0);
    }, true);

    styleBackInStockButtons();

    const observer = new MutationObserver(styleBackInStockPopup);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const initializeProductCardBackInStock = () => {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-klaviyo-notify-me]');
      if (!trigger) return;

      const productUrl = trigger.dataset.productUrl;
      if (!productUrl) return;

      event.preventDefault();
      event.stopPropagation();

      const url = new URL(productUrl, window.location.origin);
      url.searchParams.set('notify_me', '1');
      window.location.assign(url.toString());
    });

    const pageUrl = new URL(window.location.href);
    if (pageUrl.searchParams.get('notify_me') !== '1') return;

    const openBackInStockForm = () => {
      const klaviyoButton = document.querySelector(
        '.thb-product-detail button[data-a11y-identifier^="bis-button-"]'
      );
      if (!klaviyoButton) return false;

      pageUrl.searchParams.delete('notify_me');
      window.history.replaceState({}, '', `${pageUrl.pathname}${pageUrl.search}${pageUrl.hash}`);
      klaviyoButton.click();
      return true;
    };

    if (openBackInStockForm()) return;

    const observer = new MutationObserver(() => {
      if (!openBackInStockForm()) return;
      observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 10000);
  };

  const initializeKlaviyoSuppression = (trigger) => {
    if (trigger.dataset.suppressionInitialized === 'true') return;

    const suppressedFormIds = (trigger.dataset.suppressedFormIds || '')
      .split(',')
      .map((formId) => formId.trim())
      .filter(Boolean);

    if (!suppressedFormIds.length) return;

    trigger.dataset.suppressionInitialized = 'true';

    const closeSuppressedForms = () => {
      document.querySelectorAll('form[data-testid^="klaviyo-form-"]').forEach((form) => {
        const formId = form.dataset.testid.replace('klaviyo-form-', '');
        if (!suppressedFormIds.includes(formId)) return;

        const dialog = form.closest('[role="dialog"]');
        if (!dialog || dialog.dataset.themeSuppressed === 'true') return;

        dialog.dataset.themeSuppressed = 'true';
        dialog.style.setProperty('visibility', 'hidden', 'important');

        const closeButton = dialog.querySelector('.klaviyo-close-form, [aria-label="Close dialog"]');
        if (closeButton) {
          closeButton.click();
        } else {
          dialog.remove();
          document.documentElement.style.removeProperty('overflow');
          document.body.style.removeProperty('overflow');
        }
      });
    };

    closeSuppressedForms();

    const observer = new MutationObserver(closeSuppressedForms);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const initializeKlaviyoPopups = () => {
    document.querySelectorAll('[data-klaviyo-popup]').forEach((trigger) => {
      initializeKlaviyoSuppression(trigger);
      initializeKlaviyoPopupStyling(trigger);

      if (trigger.dataset.initialized === 'true') return;

      const formId = trigger.dataset.formId;
      const delay = Number.parseInt(trigger.dataset.delay, 10) || 0;
      const storageKey = `klaviyo-popup-shown-${formId}`;

      if (!formId) return;

      trigger.dataset.initialized = 'true';

      try {
        if (window.sessionStorage.getItem(storageKey)) return;
      } catch (error) {
        // Continue without session suppression when storage is unavailable.
      }

      window.setTimeout(() => {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);

        try {
          window.sessionStorage.setItem(storageKey, 'true');
        } catch (error) {
          // The Klaviyo form can still open when storage is unavailable.
        }
      }, delay * 1000);
    });
  };

  initializeBackInStockPopupStyling();
  initializeProductCardBackInStock();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeKlaviyoPopups);
  } else {
    initializeKlaviyoPopups();
  }

  document.addEventListener('shopify:section:load', initializeKlaviyoPopups);
})();
